var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "div",
            { staticStyle: { "margin-top": "5px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "back" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("back")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    no: "planIssued",
                    disabled:
                      _vm.infoCostIsEdit ||
                      _vm.form.status !==
                        _vm.SystemConstants.ASSEMBLY_PLAN_STATUS_SAVED.code
                  },
                  on: {
                    click: function($event) {
                      return _vm.editStatus(
                        _vm.SystemConstants.ASSEMBLY_PLAN_ACTION_ISSUE.code
                      )
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PlanIssued")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    no: "cancelPlanIssued",
                    disabled:
                      _vm.infoCostIsEdit ||
                      _vm.form.status !==
                        _vm.SystemConstants.ASSEMBLY_PLAN_STATUS_ISSUED.code
                  },
                  on: {
                    click: function($event) {
                      return _vm.editStatus(
                        _vm.SystemConstants.ASSEMBLY_PLAN_ACTION_CANCEL_ISSUE
                          .code
                      )
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CancelPlanIssued")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    no: "assemblyCompleted",
                    disabled:
                      _vm.infoCostIsEdit ||
                      _vm.form.status !==
                        _vm.SystemConstants.ASSEMBLY_PLAN_STATUS_ISSUED.code
                  },
                  on: {
                    click: function($event) {
                      return _vm.editStatus(
                        _vm.SystemConstants.ASSEMBLY_PLAN_ACTION_COMPLETE.code
                      )
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AssemblyCompleted")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    no: "cancelAssemblyCompleted",
                    disabled:
                      _vm.infoCostIsEdit ||
                      _vm.form.status !==
                        _vm.SystemConstants.ASSEMBLY_PLAN_STATUS_COMPLETED.code
                  },
                  on: {
                    click: function($event) {
                      return _vm.editStatus(
                        _vm.SystemConstants.ASSEMBLY_PLAN_ACTION_CANCEL_COMPLETE
                          .code
                      )
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("CargoMsg.Cargo_CancelAssemblyCompleted"))
                  )
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    no: "confirmCompleted",
                    disabled:
                      _vm.infoCostIsEdit ||
                      _vm.form.status ===
                        _vm.SystemConstants.ASSEMBLY_PLAN_STATUS_CONFIRMED.code
                  },
                  on: {
                    click: function($event) {
                      return _vm.editStatus(
                        _vm.SystemConstants.ASSEMBLY_PLAN_ACTION_CONFIRM.code
                      )
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmCompleted")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    no: "cancelConfirmCompleted",
                    disabled:
                      _vm.infoCostIsEdit ||
                      _vm.form.status !==
                        _vm.SystemConstants.ASSEMBLY_PLAN_STATUS_CONFIRMED.code
                  },
                  on: {
                    click: function($event) {
                      return _vm.editStatus(
                        _vm.SystemConstants.ASSEMBLY_PLAN_ACTION_CANCEL_CONFIRM
                          .code
                      )
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("CargoMsg.Cargo_CancelConfirmCompleted"))
                  )
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    no: "planPrint",
                    disabled: _vm.infoCostIsEdit || _vm.editable
                  },
                  on: { click: _vm.toPrint }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PlanPrint")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    no: "importAssemblyPlan",
                    disabled: _vm.infoCostIsEdit || !_vm.editable
                  },
                  on: {
                    click: function($event) {
                      _vm.importVisible = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ImportAssemblyPlan")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    no: "loadPoolDrawerVisible",
                    disabled: _vm.infoCostIsEdit || !_vm.editable
                  },
                  on: { click: _vm.openLoadPool }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_LoadingPool")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    no: "mergeUlds",
                    disabled: _vm.infoCostIsEdit || !_vm.editable
                  },
                  on: { click: _vm.mergeUlds }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MergeGroup")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    no: "delUlds",
                    disabled: _vm.infoCostIsEdit || !_vm.editable
                  },
                  on: { click: _vm.delUlds }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DeleteGroup")))]
              ),
              _c(
                "span",
                {
                  staticStyle: { "font-size": "14px", color: "red" },
                  attrs: { no: "status" }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.ColumnUtils.showTypeLabelFunc(
                          _vm.form.status,
                          _vm.SystemConstants.ASSEMBLY_PLAN_STATUS
                        )
                      ) +
                      " "
                  )
                ]
              )
            ],
            1
          ),
          _c("assembly-plan-info", {
            ref: "assemblyPlanInfo",
            attrs: {
              "origin-form": _vm.form,
              "airline-product-down-list": _vm.airlineProductDownList,
              editable: _vm.editable,
              "assembly-plan-cost-is-edit": _vm.assemblyPlanCostIsEdit
            },
            on: {
              saveAssemblyPlanSuccess: _vm.saveAssemblyPlanSuccess,
              isEdit: function(p) {
                return (_vm.assemblyPlanInfoIsEdit = p)
              }
            }
          }),
          _c("span", { staticStyle: { "margin-top": "5px" } }, [
            _vm._v(
              _vm._s(
                _vm.$t("SeaExport.OrderNumber") +
                  ": " +
                  _vm.form.itemsCount +
                  ", " +
                  _vm.$t("CargoMsg.Cargo_PieceWeightVolumeUnit") +
                  ": " +
                  _vm.form.quantityAssembly +
                  "/" +
                  _vm.form.weightAssembly +
                  "/" +
                  _vm.form.cubageAssembly +
                  "/" +
                  _vm.form.chargeWeightAssembly
              )
            )
          ]),
          _c(
            "el-tabs",
            {
              staticStyle: { height: "100%" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_Basic"),
                    name: "planContent"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "section grid-wrapper" },
                    [
                      _c("cargo-ag-grid-wrapper", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "config-module": "202206073",
                          "grid-options": _vm.gridOptions,
                          "column-defs": _vm.columnDefs,
                          "row-data": _vm.form.list,
                          "show-selected-color": false,
                          "check-sub-record": false
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_PrimeCost"),
                    name: "assemblyPlanCost"
                  }
                },
                [
                  _c("assembly-plan-cost", {
                    ref: "assemblyPlanCost",
                    attrs: {
                      form: _vm.form,
                      editable: _vm.editable,
                      "assembly-plan-info-is-edit": _vm.assemblyPlanInfoIsEdit
                    },
                    on: {
                      isEdit: function(p) {
                        return (_vm.assemblyPlanCostIsEdit = p)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  staticStyle: { height: "509px" },
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_FileHistory"),
                    name: "tabFileHistory",
                    lazy: true
                  }
                },
                [
                  _c("tab-file-history", {
                    ref: "tabFileHistory",
                    attrs: { context: _vm.context }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("load-pool-drawer", {
        attrs: {
          "airline-product-down-list": _vm.airlineProductDownList,
          visible: _vm.loadPoolDrawerVisible
        },
        on: {
          "update:visible": function($event) {
            _vm.loadPoolDrawerVisible = $event
          },
          addUldItemsToUld: _vm.addUldItemsToUld
        }
      }),
      _vm.assemblyPlanUldDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.assemblyPlanUldDialog.visible,
                title: _vm.assemblyPlanUldDialog.title,
                width: "450px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.assemblyPlanUldDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { display: "flex", "flex-wrap": "wrap" },
                  attrs: {
                    "label-width": _vm.$selectByLang("100px", "140px"),
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_NameP"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.assemblyPlanUldDialog.form.name,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.assemblyPlanUldDialog.form,
                              "name",
                              $$v
                            )
                          },
                          expression: "assemblyPlanUldDialog.form.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.editUld } },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.assemblyPlanUldDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("import-dialog", {
        attrs: {
          title: _vm.$t("CargoMsg.Cargo_ImportAssemblyPlan"),
          action: _vm.URL.booking.airExport.importUldAndJob,
          visible: _vm.importVisible,
          params: { assemblyPlanUuid: _vm.assemblyPlanUuid },
          "error-tip-detail": true,
          "folder-name": "booking",
          "file-name": "AssemblyPlanImport.xlsx"
        },
        on: {
          uploadSuccess: _vm.detail,
          onClose: function($event) {
            _vm.importVisible = false
          }
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }